/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {CCInbox} from "@app/ir-q-app-common/types/message-api";
import {MessagingModule} from "@modules/MessagingModule";
import * as React from "react";
import {useContext} from "react";
import {backgroundCell, InboxTable} from "../InboxTable";
import {UsersModule} from "@modules/UsersModule";
import {COLORS} from "@res/colors";
import {ContactsContext} from "../ContactsContext";

type Props = {
    chat: CCInbox
    onClick: () => void
    isOpen: boolean
}

export const UserCell = (props: Props) => {
    const contactContext = useContext(ContactsContext)

    const chat = props.chat;
    const isResponse = MessagingModule.isResponse(contactContext.contacts, chat);
    let nameToAppear;
    if (isResponse || !chat.lastMessage.metadata?.ghostUserId) {
        const chatContacts = chat.contactIds.map(cId => contactContext.contacts[cId]);

        const contact = chatContacts.find(_contact => _contact.contactType === "group");
        nameToAppear = `${contact?.firstName || ""} ${contact?.lastName || ""}`
    } else {
        const user = UsersModule.getUsers().find(u => u._id === chat.lastMessage.metadata?.ghostUserId);
        nameToAppear = `${user?.first || ""} ${user?.last || ""}`
    }

    const unreadMessages = MessagingModule.getNumberOfUnreadMessages(chat)

    let backgroundColor = "transparent";
    if (unreadMessages)
        backgroundColor = "#fffaf0";
    if (props.isOpen)
        backgroundColor = COLORS.primary_light_blue;

    return <div className={`ll_h_c ${backgroundCell(backgroundColor)}`} onClick={() => props.onClick()}>
        {
            InboxTable.rowStyle(nameToAppear, unreadMessages > 0)
        }
    </div>;
}
